import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c0a963c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-album" }
const _hoisted_2 = { class: "no" }
const _hoisted_3 = { class: "time c-thirdary" }

import * as filters from '@/views/filters';
import * as links from '@/views/links';

export default /*#__PURE__*/_defineComponent({
  props: {
    album: null,
    i: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.i), 1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(filters).date(__props.album.edittime || __props.album.addtime)), 1),
    _createVNode(_component_router_link, {
      class: "name line1",
      to: _unref(links).album(__props.album.movid)
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.album.title), 1)
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}
}

})